import store from 'store'
import React, { useEffect, useState } from 'react'
import constants from 'config/constants'
import Title from 'shared/components/Title'
import { useHistory, useLocation } from 'react-router-dom'
import { getInValidMessage } from '../../libs/text-validation'
import { toast } from 'libs/toast'
import useAxios from 'hooks/useAxios'
import { Form, Input } from 'semantic-ui-react'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import Page from 'shared/components/Page'
import Error from './Error'
import { trackSignupCompleted } from 'libs/track-signup-completed'

export default function CompleteSignUp() {
  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [company, setCompany] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const location = useLocation()
  const history = useHistory()

  const { fetch: callSignUp } = useAxios({
    method: 'POST',
    url: 'account/signup/',
    headers: {
      Authorization: '',
      'X-Workspace-Token': '',
    },
    skip: true,
  })

  function onSubmit() {
    setLoading(true)
    const warningMessage = getInValidMessage(password, '', company, name)
    if (warningMessage) {
      setLoading(false)
      toast.error(warningMessage)
    } else {
      callSignUp({
        data: {
          company: company,
          email: '',
          firstname: name,
          password: password,
          code: code,
        },
      })
        .then((res) => {
          const data = res.data
          if (data.token) {
            store.set(constants.simplesatTokenName, data.token)
            trackSignupCompleted('email')
            history.push(`/`)
          } else {
            store.remove(constants.simplesatTokenName)
            history.push(`/login`)
          }
        })
        .catch(() => {
          toast.error('Oops! Something went wrong. Please try again.')
          setLoading(false)
          history.push(`/login`)
        })
    }
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    if (!queryParams.has('code') && code == '') {
      toast.error(
        'Your verification link has either expired or has already been used. Please restart the sign up process to request a new link.'
      )
      history.push(`/login`)
    }
  }, [location.search, history, code])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const paramCode = queryParams.get('code')

    if (paramCode) {
      setCode(paramCode)
      history.replace('/signup/complete/')
    }
  }, [setCode, location.search, history])

  useEffect(() => {
    if (password.length > 0) {
      const warningMessage = getInValidMessage(password, '', company, name)
      if (warningMessage) {
        setError(true)
        setErrorMessage(warningMessage)
      } else {
        setError(false)
        setErrorMessage('')
      }
    }
  }, [password, company, name])

  return (
    <Page>
      <AuthenticationShell headerText="Complete sign up">
        <Title title="Complete sign up" />
        {error && <Error message={errorMessage} />}
        <Form className="ui form" onSubmit={onSubmit}>
          <div className="field">
            <label>Name</label>
            <Input
              type="text"
              name="name"
              value={name}
              maxLength={30}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label>Company name</label>
            <Input
              type="text"
              name="company-name"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label>Password</label>
            <Input
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading || error}
            onClick={onSubmit}
            className="ui fluid primary button"
          >
            Continue to your account
          </button>
        </Form>
      </AuthenticationShell>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/CompleteSignUp/index.js